module.exports = __webpack_public_path__ + "static/media/p7.85148c5f.png";